interface Holder {
	firstName: string;
	lastName?: string;
	role: 'owner' | 'resident' | 'billing_contact' | 'emergency_contact';
}

/**
 * Format an account's owner name(s) for mailing surfaces (statement "To" block,
 * envelope recipient). Prefers attached owners; collapses same-last-name owners
 * into "First1 & First2 Last", otherwise joins full names with " & ". Falls back
 * to the source-system name when no holders are attached. An emergency contact is
 * never addressed — they are not a party to the account (#569).
 */
export const formatOwnerName = (holders: Holder[], fallback: string): string => {
	const owners = holders.filter((h) => h.role === 'owner');
	const list = owners.length > 0 ? owners : holders.filter((h) => h.role !== 'emergency_contact');
	if (list.length === 0) return fallback;
	const lastNames = new Set(list.map((p) => p.lastName ?? '').filter(Boolean));
	if (lastNames.size === 1 && list.length > 1) {
		const last = list[0].lastName;
		return `${list.map((p) => p.firstName).join(' & ')} ${last ?? ''}`.trim();
	}
	return list.map((p) => `${p.firstName} ${p.lastName ?? ''}`.trim()).join(' & ');
};
